import React from "react";
import founder from "../../../assets/images/sukesh.jpg";

const FounderPage = () => {
  const email = 'sukeshv@spectsgenie.com';

  return (
    <section className="max-w-6xl mx-auto px-4 py-12 font-sans">
      <div className="flex flex-col md:flex-row items-center gap-10">
        {/* Founder Image */}
        <div className="md:w-1/2 w-full">
          <img
            src={founder}
            alt="Dr. Sukesh Voruganti"
            className="w-full rounded-2xl shadow-xl object-cover"
          />
        </div>

        {/* Founder Content */}
        <div className="md:w-1/2 w-full">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">
            Meet Our Founder
          </h2>
          <h3 className="text-xl font-semibold text-indigo-600 mb-2">
            Dr. Sukesh Voruganti
          </h3>
          <p>
        Contact us at:{' '}
        <a href={`mailto:${email}`} style={{ color: 'blue', textDecoration: 'underline' }}>
          {email}
        </a>
      </p>
          <p className="text-gray-600 mb-4">
            Dr. Sukesh Voruganti is the visionary founder behind SpectsGenie—a brand inspired by his passion for innovation, precision, and premium design. With a strong foundation in scientific research and an entrepreneurial spirit, Sukesh brings a rare blend of analytical expertise and aesthetic sensibility to the eyewear industry.
          </p>
          <p className="text-gray-600 mb-4">
            He earned his Ph.D. in Pharmaceutical Sciences from Texas Tech University Health Sciences Center, where he was actively involved in cutting-edge cancer research. His work spanned from early discovery to the clinical stage of therapeutic development, contributing to advancements in treatments targeting aggressive cancers.
          </p>
          <p className="text-gray-600 mb-4">
            Driven by a desire to make an impact beyond the lab, Dr. Voruganti transitioned into the world of fashion and founded SpectsGenie with a mission to redefine how people experience eyewear.
          </p>
          <p className="text-gray-600 mb-4">
            SpectsGenie isn’t just a brand—it’s a lifestyle. Under Sukesh’s leadership, the company combines advanced technologies like virtual try-ons with curated, fashion-forward designs that help customers see clearly and express themselves with confidence at pocket-friendly prices.
          </p>
          <p className="text-gray-600">
            At SpectsGenie, Sukesh’s vision is simple: to deliver exceptional eyewear that doesn’t just fit your face—it fits your life.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderPage;